// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dHan","title":"Info_title__34nBd","selects":"Info_selects__og6Gx","requiredAsterisk":"Info_requiredAsterisk__1zJTH"};